/* @flow */
import type { RoleList } from './defs';
import { Roles } from './defs';

//////////////////////////////////
// Asset permissions //
//////////////////////////////////
// Create Permissions //
////////////////////////

export const create: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
];

// Create Permissions > New single owned asset
export const createSingleOwnedAsset: RoleList = [Roles.ASSET_MANAGER, ...create];

// Create Permissions > New multiple owned asset for admins
export const createMultipleOwnedAsset: RoleList = [Roles.ASSET_MANAGER, Roles.SYSTEM_ADMIN];

// Create Permissions > New multiple owned asset for users roles other than Sys and Asset Manager
export const createMultipleOwnedAssetForUsers: RoleList = [
  Roles.ACCOUNT_ADMIN,
  Roles.PURCHASER,
  Roles.MANAGER,
];

// Create Permissions > Logging fault report for asset
export const createReportFault: RoleList = [Roles.USER, ...create];

// Create Permissions > Request quote for a specific rented asset
export const createRequestQuote: RoleList = [Roles.USER, ...create];

// Create Permissions > Request ownership of an asset
export const createRequestOwnership: RoleList = [Roles.USER];

// Create Permissions > Request to extend specific asset rental
export const createRequestExtendRental: RoleList = [Roles.USER];

// Create Permissions > Request allocation of asset to project
export const createRequestAllocateProject: RoleList = [Roles.USER];

// Create Permissions > Request asset calibration to be scheduled
export const createRequestAssetCalibration: RoleList = [Roles.USER];

//////////////////////
// Read Permissions //
//////////////////////
export const read: RoleList = [
  Roles.USER,
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.VIEW_ONLY,
  Roles.ACCOUNT_ADMIN,
  Roles.ACCOUNT_MANAGER,
  Roles.ASSET_MANAGER,
  Roles.BUSINESS_VIEW_ONLY,
  Roles.SYSTEM_ADMIN,
  Roles.SYSTEM_ADMIN_REGIONAL,
];

////////////////////////
// Update Permissions //
////////////////////////
export const update: RoleList = [
  Roles.MANAGER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];

// Update Permissions > Extend specific asset rental
export const updateExtendRental: RoleList = [...update];

// Update Permissions > Allocate asset to project
export const updateAllocateProject: RoleList = [Roles.SYSTEM_ADMIN_REGIONAL, ...update];

// Update Permissions > Schedule asset calibration
export const updateAssetCalibration: RoleList = [...update];

// Update Permissions > Edit rented asset
export const updateEditRentedAsset: RoleList = [Roles.ASSET_MANAGER, ...update];

// Update Permissions > Edit owned asset
export const updateEditOwnedAsset: RoleList = [Roles.ASSET_MANAGER, ...update];

// Update Permissions > Edit location asset
export const updateEditLocationAsset: RoleList = [Roles.ASSET_MANAGER, ...update];

// Update Permissions > Reassign ownership of an asset
export const updateReassignOwnership: RoleList = [
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN_REGIONAL,
  ...update,
];

// Update Permissions > Change asset location
export const updateChangeLocation: RoleList = [
  Roles.USER,
  Roles.ASSET_MANAGER,
  Roles.SYSTEM_ADMIN_REGIONAL,
  ...update,
];

// Update Permissions > Flaf sale or sub rent
export const updateFlagSaleRent: RoleList = [...update];

// Update Permissions > Upload asset documentation
export const updateUploadAssetDocs: RoleList = [
  Roles.USER,
  Roles.ASSET_MANAGER,
  Roles.ACCOUNT_MANAGER,
  ...update,
];

// Update Permissions > Download asset documentation
export const updateDownloadAssetDocs: RoleList = [
  Roles.USER,
  Roles.ASSET_MANAGER,
  Roles.ACCOUNT_MANAGER,
  Roles.SYSTEM_ADMIN_REGIONAL,
  ...update,
];

// Update Permissions > Archive unarchive owned asset
export const updateArchiveUnarchiveOwned: RoleList = [
  Roles.MANAGER,
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];

// Update Permissions > Remove asset from project
export const updateRemoveProject: RoleList = [...update];

// Audit Permissions > Assets Audit
export const auditAsset: RoleList = [
  Roles.MANAGER,
  Roles.ASSET_MANAGER,
  Roles.ACCOUNT_MANAGER,
  Roles.USER,
  Roles.PURCHASER,
  Roles.ACCOUNT_ADMIN,
  Roles.SYSTEM_ADMIN,
  // Roles.SYSTEM_ADMIN_REGIONAL,
];
